import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BaseComponent } from '../../../../../../components/base.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Reportv2Tab, Reportv2TabList } from '../../reportv2.const';
import { ReportService } from '../../../../../../common/services/Report.service';
import * as _ from 'lodash';
import * as Highcharts from 'highcharts';
import { ExportCustomService } from 'app/common/services/ExportCustom.service';
declare var require: any;
const moment = require('moment');
const HighchartsExporting = require('highcharts/modules/exporting');
import { Role } from '../../../setting/expert/expert.const';
declare var $: any;
@Component({
  selector: 'report-summary-admin',
  templateUrl: './summary-admin.component.html',
  styleUrls: ['./summary-admin.component.css'],
  providers: [ReportService, ExportCustomService],
})
export class SummaryAdminComponent extends BaseComponent implements OnChanges, AfterViewInit {
  @Output() onChangeTab: EventEmitter<{ tab: any }> = new EventEmitter();
  public backgroundList = ['#fee4cb', '#e9e7fd', '#dbf6fd', '#ffd3e2', '#c8f7dc'];
  public Role = Role;
  public TeamLeaderGroupSummary = {};
  public optionsSourceNameList = {
    doing: 'Đang xử lý',
    close: 'Đã đóng',
    solved: 'Đã giải quyết',
    open: 'Mở',
    call_report: 'Cuộc gọi đã trả lời',
    ticket_report: 'Báo cáo ticket',
    all: 'Tất cả',
  };

  public exportType = {
    SourceTicket: 'SourceTicket',
    Customer: 'Customer',
    BestAgents: 'BestAgents',
    Effort: 'Effort',
    Groups: 'Groups',
  };

  public colorsOptionsSourceName = [
    '#099516',
    '#ffd061',
    '#05027c',
    '#096c86',
    '#706f6f',
    '#c5c7cd',
    '#a2ecff',
    '#ffd9d9',
    '#ff4240',
    '#000000',
  ];
  public lengedOptionsSourceName = [];
  public isLoading = false;
  public sourceKeys = [
    { key: 'CALL_OUTBOUND', label: 'Gọi điện ra' },
    { key: 'CALL_INBOUND', label: 'Khách gọi tới' },
    { key: 'zalo', label: 'Kênh Zalo' },
    { key: 'hand', label: 'Manually' },
    { key: 'facebook', label: 'Kênh Facebook' },
    { key: 'sms', label: 'SMS' },
    { key: 'chat', label: 'Kênh Chat' },
    { key: 'email', label: 'Kênh Email' },
    { key: 'import', label: 'Import' },
    { key: 'CALL_INTERNAL', label: 'Call_internal' },
  ];
  public dataSummary: any = null;
  public optionsSourceData: any = {};
  public optionsCustomer: any = {};
  public readonly tabList = Reportv2TabList;
  public readonly Reportv2Tab = Reportv2Tab;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private reportService: ReportService,
    private exportCustomService: ExportCustomService
  ) {
    super(changeDetector, toastr, modalService);
  }
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options;

  async ngOnInit() {
    HighchartsExporting(Highcharts);
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    // Get the first and last day of the current month
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 2);
    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);

    // Format dates as strings (YYYY-MM-DD)
    const firstDayOfMonthStr = firstDayOfMonth.toISOString().split('T')[0];
    const lastDayOfMonthStr = lastDayOfMonth.toISOString().split('T')[0];
    console.log(firstDayOfMonthStr, 'firstDayOfMonthStr');
    const payload = {
      from: firstDayOfMonthStr,
      to: lastDayOfMonthStr,
    };
    this.reportService.summaryv3(payload).subscribe(
      res => {
        this.dataSummary = res.data;
        this.generateDataBestAgents();
        this.generateDataGroups();
        this.generateDataEffort();
        this.generateDataSourceTicket();
        this.generateDataCustomer();
        this.isLoading = false;
      },
      error => {
        this.dataSummary = null;
        console.error('Error fetching summary data:', error);
        this.toastr.error('Đã xảy ra lỗi khi tải dữ liệu tổng hợp', 'Lỗi');
      }
    );
  }

  generateDataBestAgents() {
    for (let i = 0; i < 5; i++) {
      if (this.dataSummary.best_agents[i] && this.dataSummary.best_agents[i].nr !== 0) {
        this.dataSummary.best_agents[i].background = this.backgroundList[i];
        this.dataSummary.best_agents[i].avatar = `assets/images/report_summary_agent_${i + 1}.png`;
      }
      if (!this.dataSummary.best_agents[i]) {
        this.dataSummary.best_agents[i] = {
          nr: 0,
          avatar: `assets/images/report_summary_agent_${i + 1}.png`,
        };
      }
    }

    // this.dataSummary.best_agents = this.dataSummary.best_agents.filter(item => item.nr > 0)
  }

  generateDataGroups() {
    this.dataSummary.groups = this.dataSummary.groups.map((item, index) => {
      item.rate = Number(item.rate.toFixed(2));
      return item;
    });

    if (this.user.role === Role.TeamLeader) {
      this.TeamLeaderGroupSummary = this.dataSummary.groups.find(e => e.group_id === this.user.group_id);
    }
  }

  generateDataEffort() {
    const done = Number(this.dataSummary.effort.done);
    const processing = Number(this.dataSummary.effort.processing);
    this.dataSummary.effort.done = done == 100 || done == 0 ? done.toFixed(0) : done.toFixed(2);
    this.dataSummary.effort.processing =
      processing == 100 || processing == 0 ? processing.toFixed(0) : processing.toFixed(2);
  }

  generateDataSourceTicket() {
    if (!this.dataSummary.source.tickets) {
      return;
    }

    this.optionsSourceData = this.dataSummary.source.tickets.map(value => {
      return {
        name: this.sourceKeys.find(key => key.key === value.key).label || value.title,
        y: value.count,
      };
    });

    const customerCustomerElement = document.getElementById('customerCustomer');
    const widthCustomer = customerCustomerElement ? customerCustomerElement.offsetWidth : 200;

    this.lengedOptionsSourceName = this.optionsSourceData.map((value, index) => {
      return {
        name: value.name,
        count: value.y,
        bg: this.colorsOptionsSourceName[index],
      };
    });

    this.optionsSourceData = {
      credits: {
        enabled: false,
      },
      xAxis: {
        type: 'category',
        labels: {
          rotation: -45,
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif',
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: '   ',
        },
      },
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            menuItems: [
              {
                text: 'Download PNG image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/png',
                    filename: `Báo cáo ticket theo nguồn ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download JPEG image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/jpeg',
                    filename: `Báo cáo ticket theo nguồn ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download PDF document',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'application/pdf',
                    filename: `Báo cáo ticket theo nguồn ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download SVG vector image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/svg+xml',
                    filename: `Báo cáo ticket theo nguồn ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download Excel',
                onclick: () => {
                  this.export(this.exportType.SourceTicket);
                },
              },
            ],
            symbol: 'menu',
            symbolStroke: '#666666',
            symbolStrokeWidth: 3,
            symbolSize: 12,
            symbolX: 12.5,
            symbolY: 10.5,
            verticalAlign: 'top',
            y: -16,
          },
        },
      },
      chart: {
        type: 'pie',
        height: 450,
        width: ((widthCustomer / 2) * 80) / 100,
        events: {
          load: function () {
            const chart = this;
            chart.renderer
              .button('Export Excel', chart.chartWidth - 100, 10, function () {
                chart.options.exporting.buttons.contextButton.menuItems[4].onclick.call(chart);
              })
              .add();
          },
        },
      },
      title: {
        text: ` `,
      },
      plotOptions: {
        pie: {
          innerSize: '70%',
          dataLabels: {
            enabled: false,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
          },
        },
      },
      series: [
        {
          name: 'Ticket',
          colorByPoint: true,
          data: this.optionsSourceData,
        },
      ],
      colors: this.colorsOptionsSourceName,
      subtitle: {
        text: `<div>
                  <div>
                  ${this.dataSummary.source.total}
                  </div>
                  <div style="font-size: 12px; color: #666666; text-align: center;">
                  Ticket
                  </div>
                </div>`,
        useHTML: true,
        align: 'center',
        verticalAlign: 'middle',
        y: 0,
        style: {
          fontSize: '30px',
          fontWeight: 'bold',
          color: '#000000',
        },
      },
    };
  }

  generateDataCustomer() {
    const dates = [];

    let categories = [];
    this.dataSummary.customers.map(e => {
      dates.push(e.time);
      if (e.contacts && e.contacts.length >= 0) {
        e.contacts.map(a => {
          let check = categories.find(i => i === a.title);
          if (!check) {
            categories.push(a.title);
          }
        });
      }
    });

    categories = categories.map(value => {
      let object = {
        name: value,
        data: [],
      };
      this.dataSummary.customers.map(a => {
        let count = a.contacts.find(e => e.title === object.name);
        if (count) {
          object.data.push(count.count);
        } else {
          object.data.push(0);
        }
      });
      return object;
    });
    const customerSourceElement = document.getElementById('customerSource');
    if (!customerSourceElement) {
      return;
    }
    const width = customerSourceElement.offsetWidth;

    this.optionsCustomer = {
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            menuItems: [
              {
                text: 'Download PNG image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/png',
                    filename: `Báo cáo khách hàng theo nguồn ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download JPEG image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/jpeg',
                    filename: `Báo cáo khách hàng theo nguồn ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download PDF document',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'application/pdf',
                    filename: `Báo cáo khách hàng theo nguồn ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download SVG vector image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/svg+xml',
                    filename: `Báo cáo khách hàng theo nguồn ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download Excel',
                onclick: () => {
                  this.export(this.exportType.Customer);
                },
              },
            ],
            symbol: 'menu',
            symbolStroke: '#666666',
            symbolStrokeWidth: 3,
            symbolSize: 12,
            symbolX: 12.5,
            symbolY: 10.5,
            verticalAlign: 'top',
            y: -16,
          },
        },
      },
      title: { text: '   ' },
      chart: {
        type: 'areaspline', // Đổi thành "areaspline" để tạo hiệu ứng tô màu dưới đường
        height: 460,
        width: width - 50,
      },
      xAxis: {
        categories: dates, // Sử dụng danh sách ngày làm trục X
        title: {
          text: 'Ngày', // Nhãn trục X
        },
      },
      yAxis: {
        title: {
          text: 'Giá trị', // Nhãn trục Y
        },
        // Xóa phần plotBands ở đây
      },
      series: categories.map(series => ({
        ...series,
        fillOpacity: 0.3, // Thêm độ trong suốt cho phần diện tích được tô màu
      })),
      plotOptions: {
        areaspline: {
          marker: {
            enabled: false, // Tắt các điểm đánh dấu để đường trơn tru hơn
          },
        },
      },
      legend: {
        layout: 'horizontal',
        align: 'center', // Center the legend horizontally
        verticalAlign: 'bottom', // Place the legend at the bottom
        symbolHeight: 12,
        symbolWidth: 12,
        symbolRadius: 6,
        itemMarginTop: 5,
        itemStyle: {
          fontSize: '13px',
          fontWeight: 'normal',
        },
      },
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.initData().then((data) => {})
  }

  generateDatenow() {
    const currentDate = new Date();
    const month = currentDate.getMonth() + 1; // getMonth() trả về giá trị từ 0-11, nên cần cộng thêm 1
    const year = currentDate.getFullYear();
    const formattedDate = `Tháng ${month} - ${year}`;
    return formattedDate;
  }

  ngAfterViewInit(): void {}

  export(type): void {
    console.log(type, 'item');
    let exportDatas: any = {
      data: [],
    };
    let data: any = {};
    let title = '';
    switch (type) {
      case this.exportType.SourceTicket:
        this.optionsSourceData.series[0].data.forEach((data, index) => {
          let data_json: any = {};
          data_json['STT'] = index + 1;
          data_json['Nguồn'] = data.name;
          data_json['Số lượng'] = data.y;
          exportDatas.data.push(data_json);
        });

        data['title'] = 'Báo cáo ticket theo nguồn';
        data['column'] = ['STT', 'Nguồn', 'Số lượng'];
        data['isDate'] = true;
        data['dates'] =
          `Từ ngày: ${moment().startOf('month').format('YYYY-MM-DD')} - Đến ngày: ${moment().endOf('month').format('YYYY-MM-DD')}`;
        data['colWidths'] = [10, 24, 40];
        title = 'Báo cáo ticket theo nguồn';
        break;
      case this.exportType.Customer:
        const dates = this.optionsCustomer.xAxis.categories;
        const dataSeries = this.optionsCustomer.series;
        exportDatas.data = dates.map((item, index) => {
          let object = {
            STT: index + 1,
            'Thời gian': item,
          };
          dataSeries.map(e => {
            object[e.name] = e.data[index] || 0;
          });
          return object;
        });
        data['title'] = 'Báo cáo khách hàng theo nguồn';
        data['column'] = ['STT', 'Thời gian', ...dataSeries.map(value => value.name)];
        data['isDate'] = true;
        data['dates'] =
          `Từ : ${moment().subtract(11, 'months').startOf('month').format('YYYY-MM')} - Đến: ${moment().endOf('month').format('YYYY-MM')}`;
        data['colWidths'] = [10, 24, ...dataSeries.map(value => 24)];
        title = 'Báo cáo khách hàng theo nguồn';
        break;
      case this.exportType.Groups:
        const dataGroups = this.dataSummary.groups;
        exportDatas.data = dataGroups.map((item, index) => {
          let object: any = {
            STT: index + 1,
            'Phòng ban': item.name,
            'Tỉ lệ %': item.rate + '%',
          };
          return object;
        });
        data['title'] = 'Báo cáo hiệu suất phòng ban';
        data['column'] = ['STT', 'Phòng ban', 'Tỉ lệ'];
        data['isDate'] = true;
        data['dates'] =
          `Từ ngày: ${moment().startOf('month').format('YYYY-MM-DD')} - Đến ngày: ${moment().endOf('month').format('YYYY-MM-DD')}`;
        data['colWidths'] = [10, 40, 24];
        title = 'Báo cáo hiệu suất phòng ban';
        break;
      default:
        break;
    }

    this.exportCustomService.exportExcelCustom(
      exportDatas.data,
      title + ' ' + moment(new Date()).format('YYYY-MM-DD HH-mm'),
      data // Adding a default sheet name as the third argument
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/summary/summary-admin/summary-admin.component.ts